module.exports = __webpack_public_path__ + "img/disruptive-behavior.acac1b55.svg";